var React = require('react');

function Oven (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M64,256V448H384V256Zm288,64H96V288H352Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M384,0H64A64,64,0,0,0,0,64v96H448V64A64,64,0,0,0,384,0ZM80,104a24,24,0,1,1,24-24A24,24,0,0,1,80,104Zm96,0a24,24,0,1,1,24-24A24,24,0,0,1,176,104Zm96,0a24,24,0,1,1,24-24A24,24,0,0,1,272,104Zm96,0a24,24,0,1,1,24-24A24,24,0,0,1,368,104ZM0,480a32,32,0,0,0,32,32H416a32,32,0,0,0,32-32V192H0ZM64,256H384V448H64Zm32,64H352V288H96Z","className":"fa-primary","key":2})]);
}

Oven.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = Oven;

Oven.default = Oven;
